// LeftSection.js
import CarouselPage from '../../Components/Carousel';  // Import the CarouselPage component
import './style.css';  // Optional: Import styles if necessary

const LeftSection = () => {
    return (
        <div className="left-section">
            <CarouselPage /> {/* Render the Carousel component here */}
        </div>
    );
};

export default LeftSection;
